import { useEffect, useRef, useState } from "react";

const MOBILE_QUERY = "(max-width: 767px)";
const SWIPE_THRESHOLD = 48;

export function useTestimonialsCarousel(totalTestimonials: number) {
  const [cardsPerPage, setCardsPerPage] = useState(3);
  const [page, setPage] = useState(0);
  const pointerStartX = useRef<number | null>(null);
  const pageCount = Math.ceil(totalTestimonials / cardsPerPage);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const updateLayout = () => {
      setCardsPerPage(mediaQuery.matches ? 1 : 3);
      setPage(0);
    };
    updateLayout();
    mediaQuery.addEventListener("change", updateLayout);
    return () => mediaQuery.removeEventListener("change", updateLayout);
  }, []);

  const safePageCount = Math.max(pageCount, 1);
  const showPrevious = () =>
    setPage((current) => (current - 1 + safePageCount) % safePageCount);
  const showNext = () =>
    setPage((current) => (current + 1) % safePageCount);
  const handlePointerDown = (event: React.PointerEvent<HTMLDivElement>) => {
    pointerStartX.current = event.clientX;
  };
  const handlePointerUp = (event: React.PointerEvent<HTMLDivElement>) => {
    if (pointerStartX.current === null) return;
    const distance = event.clientX - pointerStartX.current;
    pointerStartX.current = null;
    if (distance <= -SWIPE_THRESHOLD) showNext();
    if (distance >= SWIPE_THRESHOLD) showPrevious();
  };

  return { cardsPerPage, page, pageCount, showPrevious, showNext, handlePointerDown, handlePointerUp };
}
